import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface UpdateDashboardResponse {
  dashboard_id: string
  name: string
  bot_id: string
  external_dashboard_id: string
  token: string
  apply_bot_filter: boolean
  active: boolean
  updated_at: string
  created_at: string
}

export interface UpdateDashboardParams {
  dashboardId: string
  botId: string
  name: string
  externalDashboardId: string
  applyBotFilter: boolean
  defaultDashboard: boolean
}

export async function updateDashboard({
  dashboardId,
  botId,
  name,
  externalDashboardId,
  applyBotFilter,
  defaultDashboard,
}: UpdateDashboardParams): Promise<UpdateDashboardResponse> {
  const resp = await api.patch<UpdateDashboardResponse>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/bot/${botId}/dashboard/${dashboardId}`,
    {
      body: {
        name,
        external_dashboard_id: externalDashboardId,
        apply_bot_filter: applyBotFilter,
        default_dashboard: defaultDashboard,
      },
    },
  )

  return resp.body
}
